<template>
	<div class="min-h-screen">
		<navbar></navbar>
		<div class="carousel">
			<transition-group name="fade" tag="div" class="carousel-inner">
				<div
					v-for="(image, index) in images"
					:key="index"
					v-show="currentIndex === index"
					class="carousel-item"
				>
					<img :src="image" alt="carousel image" />
				</div>
			</transition-group>
			<div class="carousel-indicators">
				<span
					v-for="(image, index) in images"
					:key="index"
					class="indicator"
					:class="{ active: currentIndex === index }"
					@click="currentIndex = index"
				></span>
			</div>
		</div>
		<div class="max-width mx-auto py-16">
			<h2 class="text-2xl font-bold text-center text-gray-900 hotH2">热门商品</h2>
			<h2 class="text-1xl font-bold text-center text-gray-900 mb-12 hotItems">Hot Items</h2>

			<div class="grid grid-cols-6 gap-8">
				<div
					v-for="(category, index) in categories"
					:key="index"
					@mouseover="handleMouseOver(index)"
					@mouseleave="handleMouseLeave"
					:class="isHovered === index || classifyParentId === category.classifyParentId ? 'is-CaActive' : ''"
					@click="GetClassifyData(category.classifyParentId)"
					class="flex flex-col items-center p-4 border-dashed border-gray-300 rounded-lg hover:border-green-500 transition-colors cursor-pointer caga-card"
				>
					<img :src="category.image" :alt="category.name" class="" />
					<span class="text-gray-700 cagaration">{{ category.name }}</span>
					<!-- <span class="green-block"></span> -->
				</div>
			</div>
		</div>

		<!-- 商品列表 -->
		<div class="max-width mx-auto pb-16">
			<!-- <h2 class="text-2xl font-bold text-center text-gray-900 mb-12">
        热门机型
      </h2> -->
			<div class="grid grid-cols-5 gap-6">
				<div
					v-for="(product, index) in products"
					:key="index"
					@click="linkHandle('/IndividualRentDetail', product.id)"
					class="bg-white rounded-lg shadow-sm googBox_red"
				>
					<img :src="product.mainPic" :alt="product.name" class="w-full mb-4 rounded-lg" />
					<div class="p-4">
						<h3 class="text-gray-900 mb-2 text-lg line-clamp-2 h-14">{{ product.name }}</h3>
						<p class="text-gray-600 text-sm mb-2" style="color: #ff2e00">全新 顺丰包邮</p>
						<div class="flex justify-between items-baseline">
							<div class="">
								<span class="text-red-500 text-xs">¥</span>
								<span class="text-red-500 font-bold" style="font-size: 1.5rem">{{
									product.showPrice
								}}</span>
								<span class="text-red-500 text-xs">/天</span>
							</div>
							<span class="textgray text-xs">已租:{{ product.salesVolume }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="text-center mt-12">
				<button class="more-Rent-btn" @click="linkHandle('/IndividualRent')">更多热租商品</button>
			</div>
		</div>
		<div class="mx-auto pb-16 aboutBg">
			<h2 class="text-2xl font-bold text-center text-gray-900 hotH2">关于迪瓜</h2>
			<h2 class="text-1xl font-bold text-center text-gray-900 mb-12 hotItems">About Digua</h2>
			<p class="about-p">
				迪瓜租机平台是深圳市赛威客通信连锁股份有限公司（股票代码：836459）旗下全资子公司深圳维客壹佰科技有限公司自主研发基于信用大数据、区块链技术为底层，为企业和个人提供一站式信用免押的租赁服务平台。
				迪瓜租机为租赁商户提供在线化、工具化、数字化、智能化的SaaS服务，业务全链路一站式代运营，在线上获客、大数据风控、科技技术能力及供应链领域具备行业领先优势，专注于发展租赁数字化产业；为消费者提供手机、无人机、VR头显、平板电脑、游戏电玩、智能穿戴、家居家电、旅行户外等多品类产品的租赁服务。
			</p>
			<img class="ablout-img" :src="require('@/assets/img/Group 427320646.png')" alt="" />
		</div>
		<div class="max-width mx-auto pb-16">
			<h2 class="text-2xl font-bold text-center text-gray-900 hotH2">最新资讯</h2>
			<h2 class="text-1xl font-bold text-center text-gray-900 mb-12 hotItems">Latest News</h2>
			<main class="max-width mx-auto">
				<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
					<div
						v-for="(item, index) in newsItems"
						:key="index"
						@click="handleInformation(item)"
						style="height: 37.5rem"
						:class="[
							'bg-white, rounded-lg overflow-hidden shadow hover:shadow-lg transition-shadow duration-300',
							{ 'lg:col-span-2': index === 0 },
							`newStyle_${index}`,
						]"
					>
						<div class="aspect-w-16 aspect-h-9 overflow-hidden">
							<img
								:src="item.pic"
								:alt="item.title"
								class="w-full object-cover object-center"
								style="height: 28.125rem"
								:class="item.class"
							/>
						</div>
						<div class="p-4 flex sumbox">
							<div class="flex-1">
								<div class="New-time-y">
									{{ item.updateTime.substring(0, 4) }}
								</div>
								<div class="New-time-C">
									{{ item.updateTime.substring(5, 10) }}
								</div>
							</div>
							<h3 class="text-lg font-medium ml-4 line-clamp-2 newTitle">
								{{ item.title }}
							</h3>
						</div>
						<p class="text-gray-600 text-sm line-clamp-2 summary mr-4" style="">
							{{ item.summary }}
						</p>
					</div>
				</div>
			</main>
			<div class="text-center mt-12">
				<button class="more-Rent-btn text-white" @click="linkHandle('/information')">更多资讯</button>
			</div>
		</div>
	</div>
</template>

<script>
import { getProductClassify, getInformationDetails } from '@/api/index.js';

export default {
	name: 'App',
	data() {
		return {
			images: [
				require('@/assets/img/Group-427320573.gif'),
				require('@/assets/img/Group-427320573.gif'),
				require('@/assets/img/Group-427320573.gif'),
				require('@/assets/img/Group-427320573.gif'),
			],
			currentIndex: 0,
			timer: null,
			categories: [
				{
					name: '手机租赁',
					image: require('@/assets/img/Group 427320596.png'),
					classifyParentId: 115,
				},
				{
					name: '平板电脑',
					image: require('@/assets/img/Group 427320597.png'),
					classifyParentId: 119,
				},
				{
					name: '摄影航拍',
					image: require('@/assets/img/Group 427320598.png'),
					classifyParentId: 120,
				},
				{
					name: '旅游户外',
					classifyParentId: 123,
					image: require('@/assets/img/Group 427320599.png'),
				},
				{
					name: '穿戴饰品',
					classifyParentId: 122,
					image: require('@/assets/img/Group 427320600.png'),
				},
				{
					name: '游戏装备',
					classifyParentId: 128,
					image: require('@/assets/img/Group 427320601.png'),
				},
			],
			products: [],
			newsItems: [],
			isHovered: null,
			classifyParentId: null,
		};
	},
	created() {
		let data = JSON.parse(window.sessionStorage.getItem('BlankData'));
		if (data) {
			this.$router.push(data.toUrl);
			return;
		}
		//初始化热门商品类目
		this.GetClassifyData();
		this.isHovered = 0;
		this.classifyParentId = this.categories[0].classifyParentId;
		this.getInfoList();
	},
	mounted() {
		this.startCarousel();
		console.log(process.env.VUE_APP_BASE_API);
	},
	beforeDestroy() {
		this.stopCarousel();
	},
	methods: {
		getInfoList(id) {
			getInformationDetails({
				pageNum: 1,
				pageSize: 5,
			}).then(res => {
				if (res.code == 200) {
					this.newsItems = res.rows.map((item, index) => {
						return {
							...item,
							class: index == 0 ? '' : 'newsStyle',
						};
					});
				}
			});
		},
		GetClassifyData(classifyParentId) {
			this.classifyParentId = classifyParentId;
			getProductClassify({
				classifyParentId: this.classifyParentId,
			}).then(res => {
				console.log(res);
				if (res.code == 200) {
					this.products = [];
					let data = res.data;
					if (res.data.length > 10) {
						data = data.slice(0, 10);
					}
					// data = data.map(item => {
					// 	item.dayPrice = item.dayPrice.split('~')[0];
					// 	item.dayPrice = item.dayPrice.slice(1);
					// 	return item;
					// });
					this.products.push(...data);
				}
			});
		},
		handleInformation(item) {
			let data = {
				toUrl: '/information',
				data: item,
			};
			window.sessionStorage.setItem('BlankData', JSON.stringify(data));
			window.open(`/`);
			setTimeout(() => {
				window.sessionStorage.setItem('BlankData', null);
			}, 100);
		},
		linkHandle(item, id) {
			const curPath = this.$route.fullPath;
			if (curPath.includes(item)) return;
			if (item == '/IndividualRentDetail') {
				let data = {
					toUrl: '/IndividualRentDetail',
					data: null,
				};
				window.sessionStorage.setItem('BlankData', JSON.stringify(data));
				window.sessionStorage.setItem('id', id);
				window.open(`/`);
				setTimeout(() => {
					window.sessionStorage.setItem('BlankData', null);
				}, 100);
				return;
			}
			this.$router.push(item);
		},
		startCarousel() {
			this.timer = setInterval(() => {
				this.next();
			}, 2000);
		},
		stopCarousel() {
			clearInterval(this.timer);
		},
		next() {
			this.currentIndex = (this.currentIndex + 1) % this.images.length;
		},
		handleMouseOver(index) {
			// 新增方法
			this.isHovered = index;
		},
		handleMouseLeave() {
			// 新增方法
			this.isHovered = null;
		},
	},
};
</script>

<style scoped lang="scss">
.custom-input::-webkit-outer-spin-button,
.custom-input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.hotItems {
	font-family:
		PingFang SC,
		PingFang SC;
	font-weight: 400;
	font-size: 20px;
	color: #cbcbcb;
	line-height: 33px;
	font-style: normal;
	text-transform: none;
	font-weight: 300;
}

.hotH2 {
	font-size: 38px;
	line-height: 3rem;
}

.carousel {
	position: relative;
	width: 100%;
	overflow: hidden;
}

.carousel-inner {
	position: relative;
	width: 100%;
	height: 46.25rem;
}

.carousel-item {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.carousel-item img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

/* Transition effects */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}
.cagaration {
	font-family:
		PingFang SC,
		PingFang SC;
	font-size: 24px;
	color: #333333;
	line-height: 28px;
	text-align: left;
	font-style: normal;
	text-transform: none;
}
.is-CaActive .green-block {
	width: 12rem;
	height: 3px;
	background: #00733d;
	position: absolute;
	bottom: -20px; /* 根据需要调整位置 */
	left: 50%;
	transform: translateX(-50%);
}
.textgray {
	font-family:
		PingFang SC,
		PingFang SC;
	font-size: 12px;
	color: #999999;
	line-height: 33px;
	/* text-align: justified; */
	font-style: normal;
}
.more-Rent-btn {
	color: #fff;
	width: 12.25rem;
	height: 62px;
	background: #00733d;
	border-radius: 100px 100px 100px 100px;
	font-size: 24px;
	font-weight: 400;
}
.font-22 {
	font-size: 22px;
}
.is-CaActive > .cagaration {
	color: #00733d;
}
@keyframes moveUp {
	from {
		transform: translateY(0);
	}
	to {
		transform: translateY(-10px);
	}
}
.about-p {
	font-family:
		PingFang SC,
		PingFang SC;
	font-weight: 400;
	font-size: 22px;
	color: #333333;
	line-height: 40px;
	text-align: justified;
	font-style: normal;
	text-transform: none;
	text-indent: 2em;
}
.ablout-img {
	margin: 50px auto;
}
.news-container {
	width: 90rem;
}
.carousel-indicators {
	display: flex;
	justify-content: center;
	margin-top: -6.25rem;
	height: 30px;
}

.carousel-indicators span {
	width: 6px;
	height: 6px;
	background-color: #b1d8c6;
	border-radius: 50%;
	margin: 0 5px;
	cursor: pointer;
	z-index: 999;
	transition: background-color 0.3s;
}

.carousel-indicators span.active {
	background-color: #00733d;
	width: 20px;
	border-radius: 12px;
}
.aboutBg {
	background: #f5fafe;
	padding: 2.5rem 16.25rem;
	margin-bottom: 2.5rem;
}
.newsStyle {
	position: absolute;
	clip: rect(0px, 28.5rem, 28.125rem, 0px);
	width: 28.5rem;
	height: 28.125rem;
	border-radius: 7px 7px 0 0;
}
.New-time-y {
	font-family:
		PingFang SC,
		PingFang SC;
	font-size: 12px;
	color: #999999;
	line-height: 20px;
	text-align: left;
}
.New-time-C {
	font-family:
		PingFang SC,
		PingFang SC;
	font-weight: 500;
	font-size: 17px;
	color: #999999;
	line-height: 34px;
	width: 60px;
}
.newTitle {
	font-family:
		PingFang SC,
		PingFang SC;
	font-weight: 600;
	font-size: 18px;
	color: #333333;
	line-height: 27px;
	text-align: left;
	font-style: normal;
	text-transform: none;
	width: 20.8rem;
}
.New-time-C {
	color: #666;
}
.newStyle_0 {
	color: #fff;
	background-color: #fff;
	.New-time-C {
		color: #666;
	}
	.New-time-y {
		color: #666;
	}
	.newTitle {
		color: #333;
		width:49rem;
	}
	.summary {
		color: #666;
		line-height: 1.5rem;
		margin-left: 8rem;
		font-weight: 300;
	}
	&:hover {
		color: #fff;
		background-color: #454545;
		.New-time-C {
			color: #adadad;
		}
		.New-time-y {
			color: #adadad;
		}
		.newTitle {
			color: #fff;
		}
		.summary {
			color: #fff;
		}
	}
}
// .newStyle_0,
.newStyle_1,
.newStyle_2,
.newStyle_4,
.newStyle_3 {
	color: #fff;
	background-color: #fff;
	.New-time-C {
		color: #666;
	}
	.New-time-y {
		color: #666;
	}
	.newTitle {
		color: #333;
		width: 20.8rem;

	}
	.summary {
		color: #666;
		line-height: 1.5rem;
		margin-left: 6.7rem;
		font-weight: 300;
		width: 20.8rem;
	}
	&:hover {
		color: #fff;
		background-color: #454545;
		.New-time-C {
			color: #adadad;
		}
		.New-time-y {
			color: #adadad;
		}
		.newTitle {
			color: #fff;
		}
		.summary {
			color: #fff;
		}
	}
}
.caga-card {
	&:hover {
		animation: moveUp 0.5s ease-in-out forwards;
	}
}
.sumbox {
	margin-top: 28.125rem;
}
.newStyle_0 > .sumbox {
	margin-top: 0px;
}
</style>
